import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';

import template from './fix-conversion-tracking-todo-column.pug';

export class FixConversionTrackingTodoColumn extends ProjectionGridBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'FixConversionTrackingTodo',
      property: 'Opportunities/FixConversionTrackingTodo',
      title: i18n.getString('ColumnName_WhatYouCanDo') || '__what you can do__',
      bodyClasses: ['grid-column-FixConversionTrackingTodo'],
      colClasses: ['col-superLongText'],
      sortable: false,
    });
    this.i18n = i18n;
  }

  template() {
    const { i18n } = this;
    return template({
      i18n,
    });
  }

  get property() {
    return {
      get: item => _.first(item.Opportunities),
    };
  }
}
